import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CartButton = (props) => {
  const classes = classnames('cartButton', 'primary--background', {
    'cartButton--disabled': props.disabled,
  });
  return (
    <button
      disabled={props.disabled}
      className={classes}
      onClick={props.onClick}
    >
      <i className="bi_ecommerce-shopcart" />
      <span>
        <span>{props.total}</span>
        <span>{props.text}</span>
      </span>
    </button>
  );
};

CartButton.propTypes = {
  total: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CartButton;



// WEBPACK FOOTER //
// ./src/components/menu/cart-button.js